import { render, staticRenderFns } from "./defra-scopes.vue?vue&type=template&id=7efed7f8&scoped=true"
import script from "./defra-scopes.vue?vue&type=script&lang=js"
export * from "./defra-scopes.vue?vue&type=script&lang=js"
import style0 from "./defra-scopes.vue?vue&type=style&index=0&id=7efed7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efed7f8",
  null
  
)

export default component.exports